import React from "react";
import styles from "./heroSection.module.scss"
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";

const HeroSection = ({
  heroHeading,
  heroSubheading,
  heroImage,
  height = 320,
  lazyload = true
}) => (
  <div
    className={styles.heroSection__container}
    style={{ height: `${height}px` }}
  >
    {lazyload && (
      <Imgix
        className={`${styles.heroSection__background} lazyload`}
        src={heroImage.url}
        alt={heroImage.alt ? heroImage.alt : 'Hero image'}
        sizes="100vw"
        imgixParams={{ auto: 'compress,format' }}
        attributeConfig={{
          src: 'data-src',
          srcSet: 'data-srcset',
          sizes: 'data-sizes',
        }}
        htmlAttributes={{
          src: buildURL(heroImage.url, {
            auto: 'compress,format',
            blur: 50,
            w: 300,
          }),
        }}
      />
    )}
    {!lazyload && (
      <Imgix
        className={`${styles.heroSection__background}`}
        src={heroImage.url}
        alt={heroImage.alt ? heroImage.alt : 'Hero image'}
        sizes="100vw"
        imgixParams={{ auto: 'compress,format' }}
      />
    )}
    <div
      className={styles.heroSection__wrapper}
      style={{ height: `${height}px` }}
    >
      {heroHeading && (
        <h1 className={styles.heroSection__heading}>{heroHeading}</h1>
      )}
      {heroSubheading && (
        <h2 className={styles.heroSection__subHeading}>{heroSubheading}</h2>
      )}
    </div>
  </div>
);

export default HeroSection;
